import { Trans, useTranslation } from "react-i18next";
import Link from "src/components/Link";
import useAuth from "src/hooks/selectors/useAuth";

const SubscriptionEuroBanner = () => {
	const { t } = useTranslation("promotion", {
		keyPrefix: "euro-banner",
	});
	const auth = useAuth();
	const { promos, subscription } = auth.company;

	if (
		!promos?.includes("euro_subscription_deal") ||
		(subscription && !subscription.is_paused) ||
		subscription
	) {
		return <></>;
	}

	return (
		<div
			className={`bg-orange text-white text-center px-8 py-4 flex justify-center items-center flex-col rounded-md`}
		>
			<Link to="/subscription">
				<p>
					<Trans {...{ t }} i18nKey="description">
						Kies nu een naar keuze voor maar{" "}
						<strong>&euro; 1 voor de aankomende maand.</strong>{" "}
						<span className="underline">Klik hier</span> om de
						korting te claimen.
					</Trans>
				</p>
			</Link>
		</div>
	);
};

SubscriptionEuroBanner.defaultProps = {
	type: "default",
	variant: "primary",
};

export default SubscriptionEuroBanner;
